export const environment = {
  production: true,
  hmr: false,
  showConsoleLog: false,
  apiUrl: 'https://cmsnasapi.centurycodes.ng/public/api',
  courtTitle: 'HIGH COURT OF JUSTICE',
  courtTitleSentence: 'High Court of Justice',
  stateTitle: 'NASARAWA STATE',
  stateTitleSentence: 'Nasarawa State',
  currentDivision: '',
  deptTitle: 'PROBATE DEPARTMENT',
  BASE_URL: 'https://cmsnasapi.centurycodes.ng/public/api',
  BASE_URL_II: 'https://cmsnasapi.centurycodes.ng/public/api',
  API_URL: '/',
  PORTAL_URL: 'https://cmsnasportal.centurycodes.ng',
  currentState: 'Nasarawa State',
  court_bg_path: 'assets/images/court-bg.png',
  court_logo_path: 'assets/images/nas-afid-logo.png',
  paystack_public_key: 'pk_test_076e3bc8454570b1f8e9c284dc34ee6df11e2096',
  remitta_api_key: 'QzAwMDAyNTE5MzV8NTcwODYyNDl8NTk0ZGFkZTE2OWM3N2UyZTMyMzlhYWJiZjM4NjdiZThhYWQyMTUxMWVlMjNiMjdjYmFmODVlNTZlMDFlNTA5ZGZjNDVhOTliM2Q2OGNhZmE0YmI3YzllODBhMTdmNmIxMDc4ZWRlMWM5MDc1OTc4ZGYxMDQ5ZjIxYWU2Mjc0YjQ=',
  remitta_mode: 'test',
  interswitch_mechant_code: 'VNA',
  interswitch_pay_item: '103',
  interswitch_mode: 'LIVE',
  currentCourtInfoEmail: 'info@fhc.gov.ng',
  // EXTRAS
  showHelpLine: false,
  helpLine: "09137146567, 07073735972",
  showJudiciarySuffix: true,
  showState: true,
  showDivision: false,
  showSupCourtTitle: false,
  supCourtTitle:'The Judiciary,',
  supCourtTitleColor:'red',
  showAffidavitFee: false
};
